// extracted by mini-css-extract-plugin
export default {"content":"AboutMe_content__Gvui3"};